import React from "react";
import { Col, Row, Tab, Nav, Card, Spinner } from "react-bootstrap";
import PerformerCard from "./PerformerCard";
import { useTranslation } from "react-i18next";
import UpcomingTeamManager from "./UpcomingTeamManager";

const TeamPerformance = ({ data, isLoading}) => {
  const { t } = useTranslation();
    const Loader = () => (
    <div className="text-center py-3">
      <Spinner size="sm" />
    </div>
  );
  return (
    <Row className="teamPerformance">
      <Col md="12">
        <Card bg="dark1" className="h-100">
          <Card.Header className="text-light text-uppercase">
            {t("teamPerformance")}
          </Card.Header>
          <Card.Body>
            <Tab.Container defaultActiveKey="topPerformers">
              <Row className="h-100">
                <Col sm={3} className="h-100">
                  <Nav variant="pills" className="flex-row flex-md-column flex-nowrap text-nowrap overflow-auto">
                    <Nav.Item>
                      <Nav.Link eventKey="topPerformers">
                        {t("topPerformers")}
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="topRecruiters">
                        {t("topRecruiters")}
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="upcomingTeamManagers">
                        {t("upcomingTeamManagers")}
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="lowPerformers">
                        {t("lowPerformers")}
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>
                <Col sm={9} className="h-100">
                  <Row className="h-100 align-content-between">
                    <Col md="12">
                      <Tab.Content>
                         {/* Top Performers */}
                        <Tab.Pane eventKey="topPerformers">
                          {isLoading ? (
                            <Loader />
                          ) : data?.topPerformers?.length > 0 ? (
                            data.topPerformers.map((team, i) => (
                              <PerformerCard user={team} key={i} />
                            ))
                          ) : (
                            <p className="text-light">{t("noRecordFound")}</p>
                          )}
                        </Tab.Pane>

                        {/* Top Recruiters */}
                        <Tab.Pane eventKey="topRecruiters">
                          {isLoading ? (
                            <Loader />
                          ) : data?.topRecruiters?.length > 0 ? (
                            data.topRecruiters.map((team, i) => (
                              <PerformerCard user={team} key={i} />
                            ))
                          ) : (
                            <p className="text-light">{t("noRecordFound")}</p>
                          )}
                        </Tab.Pane>

                        {/* Upcoming Managers */}
                        <Tab.Pane eventKey="upcomingTeamManagers">
                          {isLoading ? (
                            <Loader />
                          ) : data?.upcomingTeamManagers?.length > 0 ? (
                            data.upcomingTeamManagers.map((team, i) => (
                              <UpcomingTeamManager user={team} key={i} />
                            ))
                          ) : (
                            <p className="text-light">{t("noRecordFound")}</p>
                          )}
                        </Tab.Pane>

                        {/* Low Performers */}
                        <Tab.Pane eventKey="lowPerformers">
                          {isLoading ? (
                            <Loader />
                          ) : data?.lowPerformers?.length > 0 ? (
                            data.lowPerformers.map((team, i) => (
                              <PerformerCard user={team} key={i} />
                            ))
                          ) : (
                            <p className="text-light">{t("noRecordFound")}</p>
                          )}
                        </Tab.Pane>

                      </Tab.Content>
                    </Col>

                    {/* My Team Stats */}
                    <Col md="12">
                      <h6 className="text-light text-uppercase">
                        {t("myTeam")}
                      </h6>

                      {isLoading ? (
                        <Loader />
                      ) : (
                        <ul className="list-unstyled d-flex justify-content-between text-light">
                          <li>
                            {t("direct")}:{" "}
                            {data?.memberCount?.directCollaboratorCount}
                          </li>
                          <li>
                            {t("first2Levels")}:{" "}
                            {data?.memberCount?.firstTwoLevelCollaboratorCount}
                          </li>
                          <li>
                            {t("totalTeam")}:{" "}
                            {data?.memberCount?.teamMemberCount}
                          </li>
                        </ul>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Tab.Container>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default TeamPerformance;
